<template>
  <div class="share-page share-page-mobile" v-if="isMobile">
    <div class="mobile-tip">请使用电脑打开</div>
  </div>
  <div class="share-page" v-else>
    <div class="share-container">
      <div class="title-bg">生产进度</div>

      <!-- 头部：项目信息 + 业务员 -->
      <v-card v-if="headerInfo" class="header-card">
        <v-card-text class="header-card-text">
          <div class="header-grid">
            <div class="header-item">
              <span class="header-label">项目名称</span>
              <span class="header-value">{{ headerInfo.project }}</span>
            </div>
            <div class="header-item">
              <span class="header-label">合同号</span>
              <span class="header-value">{{ headerInfo.code }}</span>
            </div>
            <div class="header-item">
              <span class="header-label">业务员</span>
              <span class="header-value">{{ headerInfo.salesmanName }}</span>
            </div>
            <div class="header-item">
              <span class="header-label">项目地区</span>
              <span class="header-value">
                <template v-if="headerInfo.province !== headerInfo.region">
                  {{ headerInfo.province }}{{ headerInfo.region }}
                </template>
                <template v-else>{{ headerInfo.province }}</template>
              </span>
            </div>
            <div class="header-item">
              <span class="header-label">项目类型</span>
              <span class="header-value">{{ headerInfo.projectType || '/' }}</span>
            </div>
            <div class="header-item">
              <span class="header-label">预计交期</span>
              <span class="header-value">{{ formatDeliveryIso(headerInfo.contractDeliveryTime) }}</span>
            </div>
          </div>
        </v-card-text>
      </v-card>

      <!-- 表格 -->
      <v-card class="table-card">
        <v-card-text class="pa-0">
          <div class="table-scroll">
            <v-table class="contract-table all-big-table" hover fixed-header>
              <thead>
                <tr>
                  <th class="text-center th-product">
                    <div class="align-center">产品</div>
                  </th>
                  <th class="text-center th-info">
                    <div class="align-center">产品信息</div>
                  </th>
                  <th class="text-center th-date">
                    <div class="align-center">预定交期</div>
                  </th>
                  <th class="text-center th-progress">
                    <div class="align-center">生产进度</div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="loading">
                  <td :colspan="4" class="text-center py-8">
                    <v-progress-circular indeterminate color="primary" />
                    <div class="mt-2">加载中...</div>
                  </td>
                </tr>
                <tr v-else-if="!loading && rows.length === 0">
                  <td :colspan="4" class="text-center py-8">暂无数据</td>
                </tr>
                <tr v-for="row in rows" v-else :key="row.productOrderItemId">
                  <td class="text-center td-product">
                    <div
                      v-if="firstImage(row)"
                      style="position: relative; background: rgba(0, 0, 0, 0.5); width: 100px; height: 100px; line-height: 100px; margin: 0 auto; cursor: pointer"
                      title="点击查看大图"
                      @click="onThumbClick(row)"
                    >
                      <v-img :src="firstImage(row)" width="100" height="100" />
                      <v-img
                        v-if="row.typeOf == '一厂'"
                        style="position: absolute; top: 2px; right: 2px; width: 30px; height: 18px; z-index: 99"
                        :src="allotOneImg"
                        width="100"
                        height="100"
                      />
                      <v-img
                        v-if="row.typeOf == '二厂'"
                        style="position: absolute; top: 2px; right: 2px; width: 30px; height: 18px; z-index: 99"
                        :src="allotTwoImg"
                        width="100"
                        height="100"
                      />
                      <v-img
                        v-if="row.typeOf == '三厂'"
                        style="position: absolute; top: 2px; right: 2px; width: 30px; height: 18px; z-index: 99"
                        :src="allotThreeImg"
                        width="100"
                        height="100"
                      />
                      <v-img
                        v-if="row.typeOf == '四厂'"
                        style="position: absolute; top: 2px; right: 2px; width: 30px; height: 18px; z-index: 99"
                        :src="allotFourImg"
                        width="100"
                        height="100"
                      />
                    </div>
                    <div v-else class="no-img" style="position: relative; width: 100px; height: 100px; line-height: 100px; margin: 0 auto">
                      <v-img
                        v-if="row.typeOf == '一厂'"
                        style="position: absolute; top: 2px; right: 2px; width: 30px; height: 18px; z-index: 99"
                        :src="allotOneImg"
                        width="100"
                        height="100"
                      />
                      <v-img
                        v-if="row.typeOf == '二厂'"
                        style="position: absolute; top: 2px; right: 2px; width: 30px; height: 18px; z-index: 99"
                        :src="allotTwoImg"
                        width="100"
                        height="100"
                      />
                      <v-img
                        v-if="row.typeOf == '三厂'"
                        style="position: absolute; top: 2px; right: 2px; width: 30px; height: 18px; z-index: 99"
                        :src="allotThreeImg"
                        width="100"
                        height="100"
                      />
                      <v-img
                        v-if="row.typeOf == '四厂'"
                        style="position: absolute; top: 2px; right: 2px; width: 30px; height: 18px; z-index: 99"
                        :src="allotFourImg"
                        width="100"
                        height="100"
                      />
                    </div>
                  </td>
                  <td
                    class="text-left td-info"
                    style="padding-left: 8px !important; color: rgb(143, 144, 147) !important; font-size: 12px !important;"
                  >
                    <div class="td-info-name">{{ row.name || '—' }}</div>
                    {{ row.itemCode || '—' }}<br />
                    {{ row.batch || '—' }}<template v-if="syscodeText(row)"><br /><span class="td-info-syscode">{{ syscodeText(row) }}</span></template>
                    <div class="product-info-item count-item">数量:{{ row.count ?? '—' }}</div>
                  </td>
                  <td class="text-center">{{ formatDeliveryIso(row.deliveryTime) }}</td>
                  <td class="text-center td-progress">
                    <div class="stage-strip">
                      <template v-for="cfg in stageConfigs" :key="cfg.type">
                        <div
                          v-if="!isStageMuted(row, cfg.type)"
                          class="stage-card"
                          :style="{ minWidth: `${stageCardMinWidth(cfg)}px` }"
                        >
                          <div class="stage-tag-wrap">
                            <img
                              class="stage-tag-img"
                              :src="cfg.image"
                              :alt="cfg.type"
                              loading="lazy"
                            />
                          </div>
                          <div class="stage-metrics">
                            <div class="stage-row">
                              <span class="stage-label">计划</span>
                              <span class="stage-value">{{ formatPlan(row, cfg.type) }}</span>
                            </div>
                            <div class="stage-row">
                              <span class="stage-label">实际</span>
                              <span class="stage-value">{{ formatActual(row, cfg.type) }}</span>
                            </div>
                            <div class="stage-row">
                              <span class="stage-label">完成数</span>
                              <span class="stage-value">{{ formatCompleted(row, cfg.type) }}</span>
                            </div>
                          </div>
                        </div>
                      </template>
                    </div>
                  </td>
                </tr>
              </tbody>
            </v-table>
          </div>
        </v-card-text>
      </v-card>

      <ImagePreviewDialog
        v-model="previewVisible"
        :image-list="previewImageList"
        :initial-index="previewInitialIndex"
        :is-delete="false"
        type="product"
        @close="handlePreviewClose"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import axios, { type AxiosInstance } from 'axios'
import { apiConfig, shareApi as shareApiService } from '@/services/api'
import allotOneImg from '@/assets/allotOne.png'
import allotTwoImg from '@/assets/allotTwo.png'
import allotThreeImg from '@/assets/allotThree.png'
import allotFourImg from '@/assets/allotFour.png'
import step1Img from '@/assets/step1.png'
import step2Img from '@/assets/step2.png'
import step3Img from '@/assets/step3.png'
import step4Img from '@/assets/step4.png'
import step5Img from '@/assets/step5.png'
import step6Img from '@/assets/step6.png'
import ImagePreviewDialog from '@/components/ImagePreviewDialog.vue'
import { processStatusOptions } from '@/constants/contract'

interface ProductionProgressNodeVO {
  type: string
  planEnd: number | null
  finishTime: number | null
  completedQuantity: number | null
}

interface ProductionProgressRowVO {
  productOrderItemId: number
  productOrderId: number
  project: string
  projectType?: string | null
  contractDeliveryTime?: string | null
  province?: string | null
  region?: string | null
  code: string
  salesmanId: number
  salesmanName: string
  name: string
  imageUrls: string
  itemCode: string
  batch: string
  syscode: string
  count: string
  deliveryTime: string
  typeOf: string
  progressNodes: ProductionProgressNodeVO[]
}

const STAGE_ORDER = ['备料中心', '板式', '实木', '油漆', '沙发', '成品', '出货'] as const

interface StageColumnConfig {
  type: (typeof STAGE_ORDER)[number]
  image: string
  width: number
  height: number
}

const STAGE_TAG_DISPLAY_HEIGHT = 24

const stageConfigs: StageColumnConfig[] = STAGE_ORDER.map((type) => {
  const opt = processStatusOptions.find((o) => o.title === type)
  return {
    type,
    image: (opt?.image ?? '') as string,
    width: opt?.width ?? 66,
    height: opt?.height ?? 28
  }
})

function stageCardMinWidth(cfg: StageColumnConfig): number {
  const h = cfg.height || 28
  const scaledW = Math.round(cfg.width * (STAGE_TAG_DISPLAY_HEIGHT / h))
  return Math.max(scaledW + 12, 92)
}

function createShareClient(): AxiosInstance {
  const client = axios.create({
    baseURL: apiConfig.baseURL as string,
    timeout: apiConfig.timeout,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      versionCode: '135'
    }
  })
  client.interceptors.request.use((config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.token = token
    }
    config.headers.versionCode = '135'
    return config
  })
  client.interceptors.response.use(
    (res) => res.data,
    (err) => Promise.reject(err)
  )
  return client
}

const shareApi = createShareClient()
const route = useRoute()

const isMobile = ref(false)
const rows = ref<ProductionProgressRowVO[]>([])
const loading = ref(false)

/** 从第一条数据中提取头部信息 */
const headerInfo = computed(() => {
  if (rows.value.length === 0) return null
  const first = rows.value[0]
  return {
    project: first.project,
    code: first.code,
    salesmanName: first.salesmanName,
    projectType: first.projectType,
    province: first.province,
    region: first.region,
    contractDeliveryTime: first.contractDeliveryTime
  }
})

function getNode(row: ProductionProgressRowVO, type: string): ProductionProgressNodeVO | undefined {
  return (row.progressNodes || []).find((n) => n.type === type)
}

function isStageMuted(row: ProductionProgressRowVO, type: string): boolean {
  return !getNode(row, type)
}

function syscodeText(row: ProductionProgressRowVO): string {
  const s = row.syscode
  if (s == null || s === '') return ''
  return String(s).trim()
}

function formatTsShort(ms: number | null | undefined): string {
  if (ms == null || Number.isNaN(Number(ms))) return '/'
  const n = Number(ms)
  if (n === 0) return '/'
  const d = new Date(n)
  if (Number.isNaN(d.getTime())) return '/'
  return `${d.getMonth() + 1}/${d.getDate()}`
}

function formatDeliveryIso(iso: string | undefined): string {
  if (!iso) return '/'
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return '/'
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${y}/${m}/${day}`
}

function formatPlan(row: ProductionProgressRowVO, type: string): string {
  const n = getNode(row, type)
  return formatTsShort(n?.planEnd ?? null)
}

function formatActual(row: ProductionProgressRowVO, type: string): string {
  const n = getNode(row, type)
  return formatTsShort(n?.finishTime ?? null)
}

function formatCompleted(row: ProductionProgressRowVO, type: string): string {
  const n = getNode(row, type)
  if (n?.completedQuantity == null) return '/'
  return String(n.completedQuantity)
}

function parseImageUrls(raw: string | null | undefined): { url: string }[] {
  if (raw == null || raw === '' || raw === 'null') return []
  try {
    const p = JSON.parse(raw)
    if (Array.isArray(p)) {
      return p
        .map((x: unknown) => {
          if (typeof x === 'string') return { url: x }
          if (x && typeof x === 'object' && 'url' in x && typeof (x as { url: string }).url === 'string') {
            return { url: (x as { url: string }).url }
          }
          return { url: '' }
        })
        .filter((x) => x.url)
    }
  } catch {
    if (typeof raw === 'string' && raw.startsWith('http')) {
      return [{ url: raw }]
    }
  }
  return []
}

function firstImage(row: ProductionProgressRowVO): string {
  const list = parseImageUrls(row.imageUrls)
  return list[0]?.url || ''
}

const previewVisible = ref(false)
const previewImageList = ref<string[]>([])
const previewInitialIndex = ref(0)

function openProductImagePreview(row: ProductionProgressRowVO) {
  const urls = parseImageUrls(row.imageUrls)
    .map((x) => x.url)
    .filter(Boolean)
  if (urls.length === 0) return
  previewImageList.value = urls
  previewInitialIndex.value = 0
  previewVisible.value = true
}

function onThumbClick(row: ProductionProgressRowVO) {
  if (!firstImage(row)) return
  openProductImagePreview(row)
}

function handlePreviewClose() {
  previewVisible.value = false
  previewImageList.value = []
  previewInitialIndex.value = 0
}

async function loadList() {
  const queryKeys = Object.keys(route.query)
  console.log('===========',queryKeys)
  const token = queryKeys.length > 0 ? queryKeys[0] : ''
  if (!token) {
    return
  }

  loading.value = true
  try {
    const detailRes = await shareApiService.shareProductGetId({ shareToken: token })
    if (detailRes.code !== 0 || !detailRes.data?.dataIds) {
      return
    }

    const ids: number[] = detailRes.data.dataIds
    if (!Array.isArray(ids) || ids.length === 0) {
      return
    }

    const res = await shareApiService.shareProductDetail({ productOrderItemIds: ids })

    if (res.code === 0 && res.data) {
      rows.value = res.data.records || []
    } else {
      rows.value = []
    }
  } catch {
    rows.value = []
  } finally {
    loading.value = false
  }
  document.title = headerInfo.value.project + '生产进度'
}

function checkMobile(): boolean {
  const ua = navigator.userAgent || ''
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua)
}

onMounted(() => {
  isMobile.value = checkMobile()
  if (isMobile.value) return
  loadList()
})
</script>

<style scoped>
.mobile-tip {
  color: #fff;
  font-size: 18px;
  text-align: center;
  padding: 40px 20px;
  width: 100%;
}

.share-page-mobile {
  align-items: center !important;
}

.share-page {
  min-height: 100vh;
  width: 100%;
  background-color: #2b2d33;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 16px;
}

.share-container {
  width: 100%;
  max-width: 1400px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-bottom: 44px;
}

/* 头部信息卡片 */
.header-card {
  background-color: #2b2d33 !important;
  border: 1px solid rgba(255, 255, 255, 0.12) !important;
}

.header-card-text {
  padding: 20px 24px !important;
}

.header-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 16px 32px;
}

.header-item {
  display: flex;
  align-items: baseline;
  gap: 12px;
}

.header-label {
  color: #898989;
  font-size: 14px;
  white-space: nowrap;
  flex-shrink: 0;
}

.header-value {
  color: #fff;
  font-size: 15px;
  font-weight: 500;
}

/* 表格 */
.table-card {
  background-color: #2b2d33 !important;
  flex: 1;
  display: flex;
  position: relative;
  z-index: 1;
  border: 1px solid rgba(255, 255, 255, 0.12) !important;
  box-shadow: none !important;
}

.table-scroll {
  overflow-x: auto;
  width: 100%;
}

.contract-table {
  min-width: 1000px;
  background-color: #2b2d33;
}

.contract-table :deep(th) {
  background-color: #2b2d33 !important;
  color: rgba(255, 255, 255, 0.7) !important;
  font-weight: 500;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12) !important;
  vertical-align: middle;
}

.contract-table :deep(td) {
  color: #fff !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12) !important;
  word-break: break-all;
  vertical-align: middle;
}

.contract-table :deep(tr:hover) {
  background-color: rgba(255, 255, 255, 0.05) !important;
}

:deep(.v-table th),
:deep(.v-table td) {
  padding: 10px 0 !important;
}

.contract-table :deep(th.th-product),
.contract-table :deep(td.td-product) {
  padding-right: 16px !important;
  vertical-align: middle;
}

.th-product {
  width: 106px;
}
.th-info {
  min-width: 150px;
}
.th-date {
  width: 110px;
}
.th-progress {
  min-width: 700px;
}

.contract-table :deep(td.td-info) {
  vertical-align: middle;
  word-break: break-word;
  overflow-wrap: anywhere;
}

.td-info-name {
  display: block;
  max-width: 100%;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
  margin-bottom: 0.25em;
  color: #fff !important;
}

.product-info-item {
  text-align: left;
  text-overflow: ellipsis;
  word-break: break-all;
  width: 95%;
  white-space: pre-wrap;
  line-height: 1.25;
  margin-top: 6px;
  font-size: 12px;
}
.product-info-item.count-item {
  width: fit-content;
  max-width: inherit !important;
  text-align: center;
  padding: 4px 6px;
  border: 1px solid #ffffff;
  border-radius: 2px;
  color: #fff !important;
  margin-top: 6px;
}

.td-info-syscode {
  display: block;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
}

.contract-table :deep(td.td-progress) {
  vertical-align: middle;
}

/* 生产进度列 */
.stage-strip {
  display: flex;
  flex-direction: row;
  gap: 12px;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  min-width: 620px;
}

.stage-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 0 0 auto;
  box-sizing: border-box;
  padding: 0 2px;
  background: transparent;
  border: none;
  box-shadow: none;
}

.stage-tag-wrap {
  display: flex;
  justify-content: flex-start;
  align-self: stretch;
  width: 100%;
  margin-bottom: 8px;
}

.stage-tag-img {
  display: block;
  height: 24px;
  width: auto;
  max-width: 100%;
  object-fit: contain;
  user-select: none;
  pointer-events: none;
}

.stage-metrics {
  width: 100%;
  min-width: 0;
}

.stage-row {
  position: relative;
  width: 100%;
  margin-top: 3px;
  min-height: 1.35em;
  font-size: 11px;
  line-height: 1.3;
}

.stage-row:first-child {
  margin-top: 0;
}

.stage-label {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
  white-space: nowrap;
  text-align: left;
  color: rgba(255, 255, 255, 0.74);
  font-weight: 400;
  pointer-events: none;
}

.stage-value {
  display: block;
  width: 100%;
  box-sizing: border-box;
  padding: 0 0.25em;
  padding-left: 3.5em;
  text-align: left;
  color: rgba(255, 255, 255, 0.92);
  font-variant-numeric: tabular-nums;
}

:deep(.v-card) {
  box-shadow: none !important;
}

/* 响应式：窄屏时头部网格减少列数 */
@media (max-width: 600px) {
  .header-grid {
    grid-template-columns: 1fr;
  }
  .stage-strip {
    justify-content: flex-start;
  }
}
</style>
